import gsap from 'gsap';

export function initPreloader() {
  window.scrollTo(0, 0);
  const preloaderEl = document.querySelector('[preloader]');
  if (!preloaderEl) return;

  // Track session visiting to speed up preloader on revisit
  const isVisited = sessionStorage.getItem('hasVisited');
  const durationMultiplier = isVisited ? 1 : 2.5;
  sessionStorage.setItem('hasVisited', 'true');

  // Prevent scroll during loading
  document.body.style.overflow = 'hidden';
  document.body.setAttribute('data-lenis-prevent', '');

  // Preloader elements animation
  const tl = gsap.timeline({
    onComplete: () => {
      // Release scroll on completion
      preloaderEl.style.display = 'none';
      document.body.style.overflow = '';
      document.body.removeAttribute('data-lenis-prevent');
      
      // Dispatch preloader completion event
      window.dispatchEvent(new Event('preloaderComplete'));
    }
  });

  // Reveal timeline
  tl.fromTo(preloaderEl, {
    opacity: 1
  }, {
    opacity: 0,
    duration: 0.8,
    delay: durationMultiplier,
    ease: 'power4.inOut'
  });

  // Animate preloader window scale out
  const windowEl = document.querySelector('[preloader-window-c]');
  if (windowEl) {
    tl.fromTo(windowEl, {
      yPercent: 0,
      scaleY: 1
    }, {
      yPercent: -92,
      scaleY: 0.5,
      duration: 1.2,
      ease: 'power3.inOut'
    }, `-=0.6`);
  }
}
